import { createSelector } from 'reselect'

export const namespaceKey = 'aiContentFeedback'

// action constants
export const SUBMIT_AI_CONTENT_FEEDBACK_REQUEST = `[${namespaceKey}] submit request`
export const SUBMIT_AI_CONTENT_FEEDBACK_SUCCESS = `[${namespaceKey}] submit success`
export const SUBMIT_AI_CONTENT_FEEDBACK_ERROR = `[${namespaceKey}] submit error`

// action creators
export const submitAIContentFeedbackRequestAction = () => ({
  type: SUBMIT_AI_CONTENT_FEEDBACK_REQUEST,
})

export const submitAIContentFeedbackSuccessAction = () => ({
  type: SUBMIT_AI_CONTENT_FEEDBACK_SUCCESS,
})

export const submitAIContentFeedbackErrorAction = () => ({
  type: SUBMIT_AI_CONTENT_FEEDBACK_ERROR,
})

// selectors
const stateSelector = (state) => state?.[namespaceKey]

export const getAIContentFeedbackSubmittingSelector = createSelector(
  stateSelector,
  (state) => state?.submitting || false
)

// initial state
const initialState = {
  submitting: false,
}

// reducer
export const reducer = (state = initialState, { type }) => {
  switch (type) {
    case SUBMIT_AI_CONTENT_FEEDBACK_REQUEST:
      return { ...state, submitting: true }
    case SUBMIT_AI_CONTENT_FEEDBACK_SUCCESS:
    case SUBMIT_AI_CONTENT_FEEDBACK_ERROR:
      return { ...state, submitting: false }
    default:
      return state
  }
}
